import { render, staticRenderFns } from "./HistologGridOverlay.vue?vue&type=template&id=04f8672b"
import script from "./HistologGridOverlay.vue?vue&type=script&lang=js"
export * from "./HistologGridOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports